import {IndexPageModule} from "@/settings";
import {sendMessage} from '@/api/chatbot';
import {JumpLink} from '@/settings'
import {logisticsInfo} from '@/api/chatbot'
import {getCurrentDate} from '@/utils/date'
import {getChatHistory} from "@/api/chatbot";
import store from "@/store";
const originID = `${process.env.VUE_APP_XCX_ORIID}`

/**
 * URL safe base64 encode
 */
export function urlSafeBase64Encode(str) {
    return btoa(str).replace(/\//g, '_').replace(/\+/g, '-');
}

/**
 * 获取页面的标题，有默认值
 * @param {string} title 标题来源，无效则使用默认值
 * @returns string | 'VUE 2'
 */
export function getPageTitle(title) {
    if (document.title === title || document.title === '') {
        return title;
    }
    return `${document.title}-${title}`
}


/**
 * bot回复消息解析
 * @param {string} message Bot 回复的消息
 */
export function messageParse(message) {
    let options = message.split(new RegExp('[0-9]+\\.[ ]*', 'g')) || [] // 提取选项
    options = options.map(item => {
        // if (item.trim()) return item.replaceAll(new RegExp('<br[ ]*/>', 'g'), '')
        if (item.trim()) {
            return item.replaceAll(new RegExp('&lt;/br&gt;', 'g'), '').replaceAll(new RegExp('<br[ ]*/>', 'g'), '')
        }
    }) // 去掉换行符
    let title = options.shift() // 去掉第一个, 并设置title
    let type = options.length != 0 ? 'select' : 'text' // 判断是否有选择项
    if (type == 'select' && options.length == 2 && options.indexOf('是') != -1 && options.indexOf('否') != -1) {
        type = 'dialog'
    }
    return {
        content: message,
        title,
        type,
        options,
    }
}


/**
 * 滚动到底部
 * @param {string} el 滚轮所在元素
 */
// export function scrollToBottom(el) {
//     clearInterval(window.T);
//     window.T = setInterval(() => {
//         // console.log('各种高度', el.scrollHeight, el.scrollTop, el.clientHeight, el.offsetHeight);
//         let offsetHeight = el.offsetHeight
//         if (el.scrollHeight != el.clientHeight) offsetHeight = el.clientHeight
//         const n = el.scrollHeight - el.scrollTop - offsetHeight
//         if (n > 1) {
//             const l = 1.1 ^ (n / 10.0) + 2
//             el.scrollTop += l;
//             // console.log(l);
//         } else {
//             clearInterval(window.T);
//             window.scrolling = false;
//         }
//     }, 1);
// }


/**
 * 滚动到底部
 * @param {string} el 滚轮所在元素
 */
export function scrollToBottom(el) {
    clearInterval(window.T);
    window.T = setInterval(() => {
        if (el) {
            // const chatbotQElList = el.querySelectorAll('.chatbot-q'); // 问题节点列表
            const chatbotQElList = el.querySelectorAll('.container_mapper_item'); // 问题节点列表
            const lastchatbotQEl = chatbotQElList[chatbotQElList.length - 1]; // 最后一个问题节点
            const wapperHeight = el.scrollHeight != el.clientHeight ? el.clientHeight : el.offsetHeight; // 滚轮容器的可视高度
            const offsetHeight = (el.scrollHeight != el.clientHeight ? lastchatbotQEl.clientHeight : lastchatbotQEl.offsetHeight) + 50; // 最底部元素的可视高度
            const scrollSurplusHeight = el.scrollHeight - el.scrollTop; // 滚轮条剩余的高度
            const newScrollSurplusHeight = (wapperHeight > offsetHeight ? wapperHeight : offsetHeight); // 滚动条应当预留的高度
            if (scrollSurplusHeight > newScrollSurplusHeight) {
                // 未滚动到预定位置
                const l = 1.1 ^ ((scrollSurplusHeight - newScrollSurplusHeight) / 10.0) + 2
                el.scrollTop += l;
                if ((scrollSurplusHeight - newScrollSurplusHeight) < l) {
                    clearInterval(window.T);
                }
            } else {
                clearInterval(window.T);
            }
        }
    }, 1);
}

/**
 * 判断是否是需要忽略的历史消息
 * @param {string} content 用户输入的内容
 */
export function isIgnore(content) {
    const indexPageItems = []
    for (let i = 0; i < IndexPageModule.length; i++) {
        const {value} = IndexPageModule[i]
        indexPageItems.push(value)
    }
    if (indexPageItems.indexOf(content) != -1) {
        return true
    } else {
        return false
    }
}

export async function historyMessageParse(data, unshift = false) {
    const {user_input, answer: result} = data
    let messageData = {}
    let insertLink = ''
    let str = ''
    const len = JumpLink.length;

    const fun = async (result, asType) => {
        insertLink = result
        for (let i = 0; i < len; i++) {
            let { text, link, showTitle } = JumpLink[i]
            if (result.includes(text) && (text === '【积分社区】👈' || text === '【积分规则】👈' || text === '【积分兑换】👈')) {
                insertLink = insertLink.replaceAll(text, `
                    <wx-open-launch-weapp id="launch-btn" username="${originID}" path="${link}" >
                        <script type="text/wxtag-template">
                            <style>.open-wxminiapp{text-decoration: underline; color: #d72618; font-size:16px;}</style>
                            <span class="open-wxminiapp"> ${text} </span>
                        </script>
                    </wx-open-launch-weapp>
                `)
            } else if (result.includes(text)) {
                insertLink = insertLink.replaceAll(text, `<span class="red" onclick="openLink('${link}')">${showTitle ? showTitle : text}</span>`)
            }
        }

        if (insertLink.includes("400-821-9765")) {
            insertLink = insertLink.replaceAll('400-821-9765', '<a class="red" href="tel:400-821-9765">400-821-9765 </a>')
        }

        const isLogistics = insertLink.includes("{{物流查询}}")
        if (isLogistics) {
            insertLink = insertLink.replaceAll('{{物流查询}}', '')
            const result = await logisticsInfo()
            const { data } = result;
            const len = data.length;
            for (let i = 0; i < len; i++) {
                const { goods, timestamp, orderId, mailNo, status } = data[i]
                const getDate = getCurrentDate(timestamp * 1000)
                const getOrderId = orderId ? orderId : '1234567890'
                const getMailNo = mailNo ? mailNo : '1234567890'
                str += `时间：<span class="goods" >${getDate}</span> 物品：<span class="goods">${goods}</span> 订单号：<span class="red" onclick="nextStep('${goods}','${getDate}','${getOrderId}','${getMailNo}','${status}')">${getOrderId}</span><br /><div style="height:0.5rem"></div>`
            }
            insertLink += `<br /> ${str}`
        }
        const isMultiQuestion = insertLink.includes("<br>1.是<br>2.否")
        if (isMultiQuestion) {
            insertLink = insertLink.replaceAll('1.是<br>2.否', '')
        }
        messageData = {
            answer: insertLink,
            type: 'qa',
            isMultiQuestion,
            history: true
        }
        if (asType === 'master') messageData.userInput = user_input;
        store.commit('set_messageList', {
            item: messageData,
            unshift,
        });
    }

    const { as, child } = answerSplit(result);
    await fun(as, 'master');
    if (child) {
        // 有分离语句
        for (const item of child) {
            await fun(item, 'child');
        }
    }
    
    
}

export async function getMessageList(value, that) {
    const res = await sendMessage(value);
    const {data: answer, datetime} = res
    const isObj = Object.prototype.toString.call(answer) === '[object Object]'
    let messageData = {}
    let insertLink = ''
    let str = ''
    if (isObj) {
        const {datetime, over, result, type, userInput, item_id} = answer
        that.$store.commit('set_itemId', item_id);
        const len = JumpLink.length;

        const fun = async (result, asType) => {
            insertLink = result

            for (let i = 0; i < len; i++) {
                let { text, link, showTitle } = JumpLink[i]
                if (result.includes(text) && (text === '【积分社区】👈' || text === '【积分规则】👈' || text === '【积分兑换】👈')) {
                    insertLink = insertLink.replaceAll(text, `
                        <wx-open-launch-weapp id="launch-btn" username="${originID}" path="${link}" >
                        <script type="text/wxtag-template">
                            <style>.open-wxminiapp{text-decoration: underline; color: #d72618; font-size:16px;}</style>
                            <span class="open-wxminiapp"> ${text} </span>
                        </script>
                        </wx-open-launch-weapp>
                    `)
                } else if (result.includes(text)) {
                    insertLink = insertLink.replaceAll(text, `<span class="red" onclick="openLink('${link}')">${showTitle ? showTitle : text}</span>`)
                }
            }

            if (insertLink.includes("400-821-9765")) {
                insertLink = insertLink.replaceAll('400-821-9765', '<a class="red" href="tel:400-821-9765">400-821-9765 </a>')
            }

            const isLogistics = insertLink.includes("{{物流查询}}")
            if (isLogistics) {
                insertLink = insertLink.replaceAll('{{物流查询}}', '')
                const result = await logisticsInfo()
                // console.log('logisticsInfo', result)
                const { data } = result;
                1
                const len = data.length;
                for (let i = 0; i < len; i++) {
                    const { goods, timestamp, orderId, mailNo, status } = data[i]
                    const getDate = getCurrentDate(timestamp * 1000)
                    const getOrderId = orderId ? orderId : '1234567890'
                    const getMailNo = mailNo ? mailNo : '1234567890'
                    str += `时间：<span class="goods">${getDate}</span> 物品：<span class="goods">${goods}</span> 订单号：<span class="red" onclick="nextStep('${goods}','${getDate}','${getOrderId}','${getMailNo}','${status}')">${getOrderId}</span><br /><div style="height:0.5rem"></div>`
                }
                insertLink += `<br /> ${str}`
            }
            const isMultiQuestion = insertLink.includes("<br>1.是<br>2.否")
            if (isMultiQuestion) {
                insertLink = insertLink.replaceAll('1.是<br>2.否', '')
            }

            messageData = {
                datetime,
                over: over || type,
                answer: insertLink,
                type: 'qa',
                isMultiQuestion,
                item_id,
                history: false
            }
            if (asType === 'master') messageData.userInput = userInput;
            that.$store.commit('set_messageList', messageData);
        }

        const { as, child } = answerSplit(result);
        await fun(as, 'master');
        if (child) {
            // 有分离语句
            for (const item of child) {
                await fun(item, 'child');
            }
        }
    } else {
        messageData = {
            datetime,
            userInput: value,
            answer,
            type: 'qa',
        }
        that.$store.commit('set_messageList', messageData);
    }
}

/**
 * 根据物流订单返回状态显示相应对话
 * @param {string} content 用户输入的内容
 */
export function logisticsNextStep(goods, timestamp, orderId, mailNo, status, that) {
    // console.log('goods, timestamp, orderId, mailNo, status, that', goods, timestamp, orderId, mailNo, status, that)
    if (goods === '针头') {
        const data = {
            userInput: `时间：${timestamp}<br/>物品：${goods}<br/>订单号：${orderId}`,
            answer: `您好！您的订单物流信息请点击<span class="red" onclick="gotoLogisticsDetails('${orderId}')">【订单详情】</span>查看。`,
            type: 'qa',
            over: true
        }
        that.$store.commit('set_messageList', data);
    } else {
        if (status === '1') {
            const data = {
                userInput: `时间：${timestamp}<br/>物品：${goods}<br/>订单号：${orderId}`,
                answer: `您好！已为您查询到您的订单已发货， 物流单号是${mailNo}， 请复制快递单号查询最新物流信息。`,
                type: 'qa',
                over: true
            }
            that.$store.commit('set_messageList', data);
        } else {
            const data = {
                userInput: `时间：${timestamp}<br/>物品：${goods}<br/>订单号：${orderId}`,
                answer: `您好！请您耐心等待，您的订单将会在后续安排寄出， 请您及时关注微信消息。`,
                type: 'qa',
                over: true
            }
            that.$store.commit('set_messageList', data);
        }
    }
}


/**
 * 聊天记录懒加载
 */
export function lazyLoadHistory() {
    window.touchGlide = async () => {
        const el = document.querySelector('#el-main')
        if (el) {
            const oldH = el.scrollHeight
            if (el.scrollTop == 0 && store.state.page !== 0) {
                // 聊天记录的获取
                store.commit('set_page', store.state.page + 1)
                const history = await getChatHistory(store.state.page);
                if (history.data.totalPage <= store.state.page) store.commit('set_page', 0);
                for (const item of history.data.list) {
                    if (!isIgnore(item.user_input)) {
                        await historyMessageParse(item, true);
                        const t = setInterval(() => {
                            const newH = el.scrollHeight - oldH
                            if (newH > 0) {
                                el.scrollTop = el.scrollHeight - oldH
                                clearInterval(t)
                            }
                        }, 10);
                    }
                }
            }
        }
    }

}


/**
 * 聊天记录懒加载
 */
// export function lazyLoadHistory() {
//     // 监听元素滚动事件
//     const timeId = setInterval(() => {
//         const el = document.querySelector('#el-main')
//         if (el) {
//             el.addEventListener('scroll', async function () {
//                 // console.log('#el-main scroll', el.scrollTop, el.scrollHeight, el.clientHeight);
//                 const oldH = el.scrollHeight
//                 if (el.scrollTop == 0 && store.state.page !== 0) {
//                     // 聊天记录的获取
//                     store.commit('set_page', store.state.page + 1)
//                     const history = await getChatHistory(store.state.page);
//                     if (history.data.totalPage <= store.state.page) store.commit('set_page', 0);
//                     for (const item of history.data.list) {
//                         if (!isIgnore(item.user_input)) {
//                             await historyMessageParse(item, true);
//                             const t = setInterval(() => {
//                                 const newH = el.scrollHeight - oldH
//                                 if (newH > 0) {
//                                     el.scrollTop = el.scrollHeight - oldH
//                                     clearInterval(t)
//                                 }
//                             }, 10);
//                         }
//                     }
//                 }
//             }, false)

//             clearInterval(timeId)
//         }
//     }, 100)

// }


// 判断是否是对象
export function isObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
}

// 判断是否是数组
export function isArray(obj) {
    return Object.prototype.toString.call(obj) === '[object Array]';
}

// 关闭窗口
export function closePage() {
    if (navigator.userAgent.indexOf("Firefox") != -1 || navigator.userAgent.indexOf("Chrome") != -1) {
        window.location.href = "about:blank";
        window.close();
    } else {
        window.opener = null;
        window.open("", "_self");
        window.close();
    }
}


// 判断是否为空
export function isEmpty(obj) {
    if (obj == null || obj == undefined || obj == '') {
        return true;
    } else {
        return false;
    }
}

// 获取cookie
export function getCookie(key) {
    const as = document.cookie.match(new RegExp(`${key}=[^;]*`));
    if (as && as.length > 0) {
        return as[0].split('=')[1];
    } else {
        return null;
    }
}

// 设置cookie
export function setCookie(key, val) {
    if (val == null || val == undefined || val == '') {
        document.cookie = `${key}=${val}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    } else {
        document.cookie = `${key}=${val}`;
    }
}


// updateMessageList
export function updateMessageList(that, itemId) {
    const message = that.$store.getters.get_messageList
    const updatedMessage = message.map((item) => {
      if(item.item_id === itemId){
        item.history = true
      }
      return item
    })
    that.$store.commit('update_messageList', updatedMessage); 
}

// 判断是否是方法
export function isFunction(fn) {
    return Object.prototype.toString.call(fn) === '[object Function]' || Object.prototype.toString.call(fn) === '[object AsyncFunction]';
}

/**
 * 提取分离语句
 * @param {*} answer 
 * @returns String | Array
 */
export function answerSplit(answer) {
    if (answer) {
        // 提取 [此处是分离语句的开始: xxxxxx :此处是分离语句的结束] 中的内容
        const reg = /\[此处是分离语句的开始: (.*?) :此处是分离语句的结束\]/g;
        const result = answer.match(reg);
        if (result && result.length > 0) {
            // 有分离语句
            const newAnswer = answer.replace(reg, ''); // 使用正则表达式替换掉分离语句
            const newResult = result.map((item) => item.substring(12, item.length - 12));
            return { as: newAnswer, child: newResult };
        }
    }
    // 没有分离语句
    return { as: answer };
}